
import React, { useState, useEffect } from 'react';

import '../styles/landingStyle.css';

import logo from "../asstes/logo.png";
import back from '../asstes/backPNG.PNG'

import arrow from "../asstes/dashboard/arrow.png"

import loadingIcon from "../asstes/loadingIcon.gif";
import trackingImg from "../asstes/tracking.gif"
import emailjs from '@emailjs/browser';

import { getDatabase, ref, set, push, get } from "firebase/database";
import { animate, motion } from "framer-motion";

import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";


import closeImg from "../asstes/dashboard/exitWhite.png"
import fb from "../asstes/fb.png"
import insta from "../asstes/insta.png"

import coloredFb from "../asstes/coloredFb.png"

import ColoredInsta from "../asstes/coloredInsta.png"

import ColoredWhat from "../asstes/coloredWhatsApp.png"

import email from "../asstes/email.png"

import service2 from "../asstes/service2.gif"

import service3 from "../asstes/service3.gif"

import service4 from "../asstes/service4.gif"

import phone from "../asstes/dashboard/phone.png"


import {db} from "../Components/database_config/firebaseConfig"


const Landingpage = () => {


  const navigate = useNavigate();
  const location = useLocation();

  const [username, setUsername] = useState("");

  const [password, setPassword] = useState("");

  const [showLoadingLogin, setShowLoadingLogin] = useState(false);

  const [showLoginEmpty, setShowLoginEmpty] = useState(false);
  const [showLoginFailed, setShowLoginFailed] = useState(false);


  const [showDashboard, setShowDashboard] = useState(false);


  const [showSignUp, setShowSignUp] = useState(false);


  const [showLoadingSignUp, setShowLoadingSignUp] = useState(false);



  const [showEmailConf, setShowEmailConf] = useState(false);


  const [signUpEmpty, setSignUpEmpty] = useState(false);

  const [passwordNotConfirmed, setPasswordNotConfirmed] = useState(false);


  const [emailConf, setEmailConf] = useState("");


  const [showemailConf, setShowemailConf] = useState(false);


  const [clientName, setClientName] = useState("");

  const [clientPhone, setClientPhone] = useState("");

  const [clientEmail, setClientEmail] = useState("");

  const [clientLocation, setClientLocation] = useState("");

  const [clientPassword, setClientPassword] = useState("");

  const [confirmPassword, setConfirmPassword] = useState("");

  const [clientCompany, setClientCompany] = useState("");

  const [clientBusiness, setClientBusiness] = useState("");


  const wilayaNames = [
    "Adrar", "Chlef", "Laghouat", "Oum El Bouaghi", "Batna", "Béjaïa", "Biskra", "Bechar", "Blida", "Bouira",
    "Tamanrasset", "Tbessa", "Tlemcen", "Tiaret", "Tizi Ouzou", "Alger", "Djelfa", "Jijel", "Se9tif", "Saefda",
    "Skikda", "Sidi Bel Abbes", "Annaba", "Guelma", "Constantine", "Medea", "Mostaganem", "M'Sila", "Mascara",
    "Ouargla", "Oran", "El Bayadh", "Illizi", "Bordj Bou Arreridj", "Boumerdes", "El Tarf", "Tindouf", "Tissemsilt",
    "El Oued", "Khenchela", "Souk Ahras", "Tipaza", "Mila", "Ain Defla", "Naama", "Ain Temouchent", "Ghardaefa",
    "Relizane", "El M'ghair", "El Menia", "Ouled Djellal", "Bordj Baji Mokhtar", "Béni Abbès", "Timimoun",
    "Touggourt", "Djanet", "In Salah", "In Guezzam"
  ];




  const [codeGen, setCodeGen] = useState(false);

  const [showEmailConfMsg, setShowEmailConfMsg] = useState(false);

  const [navPage, setnavPage] = useState(1);


  const genRandomCode = (length) => {

    let number = "";

    for (let i = 0; i < length; i++) {
      number = number.concat(Math.floor(Math.random() * 10));
    }

    return number;

  }


  const signUp = () => {


    const db = getDatabase();
    push(ref(db, 'Client'), {
      business_nature: clientBusiness,
      company_name: clientCompany,
      name: clientName,
      location: clientLocation,
      tel_number: clientPhone,
      email: clientEmail,
      password: clientPassword,
      signup_date: Date.now(),
      status: false
    });
    console.log("Client Added: [" + clientName + "]");




  }

  const sendEmail = () => {

    setShowLoadingSignUp(true);
    if (clientName === "" || clientEmail === "" || clientPassword === "" || confirmPassword === "" || clientCompany === "" || clientBusiness === "" || clientPhone === "" || clientLocation === "") {
      setSignUpEmpty(true);
      console.log("SignUp Fields Empty!");
      setTimeout(() => {
        setSignUpEmpty(false)

        setShowLoadingSignUp(false);
      }, 3000);
    } else {
      if (clientPassword !== confirmPassword) {
        setPasswordNotConfirmed(true);
        console.log("Incorrect Password!");
        setTimeout(() => {
          setPasswordNotConfirmed(false)

          setShowLoadingSignUp(false);
        }, 3000);

      }
      else {

        let code = genRandomCode(6);
        setCodeGen(code);
        console.log(code);

        setShowEmailConf(true)

        var template_params = {
          email_content: "Your code of confirmation is: " + code,
          recipient_email: clientEmail,
          recipient_name: clientName,
          recipient_phone: clientPhone
        }

    
setShowLoadingSignUp(false);
    emailjs.init("h0ccV5CndNZXi2MXt");
    emailjs.send("service_b6v0zjq","template_6lq2fnq",template_params);
  }
}

  }

  const login = () => {
    if (username == "" || password == "") {
      setShowLoginEmpty(true)
      setTimeout(() => {
        setShowLoginEmpty(false)
      }, 3000)
    } else {
      setShowLoadingLogin(true)
      const db = getDatabase();

      const tasksRef = ref(db, "Client");

      get(tasksRef)
        .then((snapshot) => {
          const data = snapshot.val();
          const list = Object.entries(data)


          var login = false;
          list.forEach(element => {
            if (element[1].email.toLowerCase() == username.toLowerCase() && element[1].password == password) {
              console.log(element[0])
              console.log("login")
              login = true;

              setTimeout(() => {
                setShowDashboard(true)
              }, 2000)
              setTimeout(() => {
                navigate('/client', { state: { userId: element[0] } });
              }, 3000)

              return
            }
          });

          if (!login) {
            console.log("login failed")

            setShowLoginFailed(true)
            setTimeout(() => {
              setShowLoginFailed(false)
              setShowLoadingLogin(false)
            }, 3000)
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }


  useEffect(() => {

    window.addEventListener('click', function (e) {
      if (document.getElementById('signIn-overlay') != null && document.getElementById('show-overlay-btn') != null) {
        if (!document.getElementById('signIn-overlay').contains(e.target) && !document.getElementById('show-overlay-btn').contains(e.target)) {
          setShowSignUp(false);
        }
      }

    });

  }, []);

  return (
    <motion.div class="landing-colored-back">


      <motion.div class="landing-loading flex flex-column align-center justify-center"
        initial={{ opacity: 1 }}
        animate={{ opacity: 0, transition: { delay: 2 } }}
      >


        <img className="" src={logo} alt="" />
        <div className='landing-loading-line relative'>



          <motion.div class="landing-loading-line-anim absolute"
            initial={{ width: 0 }}
            animate={{ width: "100%", transition: { duration: 2 } }}
          ></motion.div>


        </div>
      </motion.div>

      <motion.div class="landing-loaded"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, transition: { delay: 3 } }}
      >


        <div class="landing-back-white">

        </div>

        <div class="landing-back top-right-orange">

        </div>

        <div class="landing-back top-right-blue">

        </div>

        <div class="landing-back bottom-left-orange white-text bold">
          <div class="contact-item flex align-center">
            <img className="logo" src={insta} alt="Instagram" />

            <div class="contact-info">
              <p>Korsaa_gof21</p>
            </div>

          </div>

          <div class="contact-item flex align-center">
            <img className="logo" src={fb} alt="Facebook" />
            <div class="contact-info">
              <p>Korsaa Gof</p>
            </div>

          </div>

          <div class="contact-item flex  align-center">
            <img className="logo" src={email} alt="Gmail" />
            <div class="contact-info">
              <p>Korsaagof@gmail.com</p>
            </div>
          </div>

          <div class="contact-item flex align-center">
            <img className="logo" src={phone} alt="Phone" />
            <div class="contact-info">
              <p>+213 670356842</p>
            </div>
          </div>

        </div>

        <div class="landing-back bottom-left-blue">

        </div>


        <motion.div class="landing-container tracking-container service-section flex align-center justify-center"

          animate={navPage == 2 ? { top: 0 } : { top: "100%" }}
        >


          <p className='absolute bold section-title'>nos services </p>


          <div class="services-container flex align-center justify-center max-width">

            <div class="service-item bold flex flex-column align-center">
              <motion.img className="" src={trackingImg} />
              <p>nous fournissons un service de transport rapide organisé garanti qui comprend des voies et des semi-camions</p>
            </div>

            <div class="service-item bold flex flex-column align-center">
              <motion.img className="" src={service2} />
              <p>nous sommes un médiateur entre les transporteurs et leurs entreprises</p>
            </div>

            <div class="service-item bold flex flex-column align-center">
              <motion.img className="" src={service3} />
              <p>Nous surveillons et suivons la continuité et la fluidité des livraisons</p>
            </div>

            <div class="service-item bold flex flex-column align-center">
              <motion.img className="" src={service4} />
              <p>nous fournissons une plate-forme facile à utiliser qui donne accès à un réseau de transporteurs de confiance et légalisé</p>
            </div>

            <div class="service-item bold service-responsive">
              <motion.img className="" src={service4} />
              <p>nous fournissons une plate-forme facile à utiliser qui donne accès à un réseau de transporteurs de confiance et légalisé</p>
            </div>


          </div>
        </motion.div>
        <motion.div class="landing-container about-section flex align-center justify-center bold"

          animate={navPage == 3 ? { top: 0 } : { top: "100%" }}
        >


          <p className='absolute bold section-title'>À Propos de Nous</p>
          <div className='left-about flex flex-column '>
            <motion.img className="" src={logo} />
            <p>Le transport a toujours été un facteur essentiel dans toute entreprise à travailler Easley en le rendant rapide garanti et organisé si ces éléments sont là le marketing de l’entreprise deviendra encore mieux et notre site Web aide à créer le confort et la crédibilité pour les entreprises à prospérer et se développer et fondamentalement nous sommes un médiateur entre les entreprises et les moyens de transport et nous aidons à simplifier la communication entre eux en ajoutant que nos services sont sécurisés en vérifiant la légalité des transporteurs avec lesquels nous traitons</p>
          </div>

          <div className='right-about flex flex-column  align-center'>
            <p>Batna Centre, Batna, Algérie</p>
            <p>+213 670356842</p>
            
          </div>

        </motion.div>


        <div className='landing-container nav'>
          <div class="landing-logo">
            <img className="logo" src={logo} alt="" />
          </div>

          <div class="landing-header">
            <div class="landing-nav bold flex align-center justify-center">
              <div class="landing-nav-item"
                onClick={() => {
                  setnavPage(1)
                }}>
                <p>Accueil</p>

                <motion.div class="selected-nav"
                  initial={{ width: "100%" }}
                  animate={navPage == 1 ? { width: "100%" } : { width: 0 }}

                >
                </motion.div>
              </div>

              <div class="landing-nav-item"
                onClick={() => {
                  setnavPage(2)
                }}>
                <p>Services</p>
                <motion.div class="selected-nav"
                  initial={{ width: "0%" }}
                  animate={navPage == 2 ? { width: "100%" } : { width: 0 }}

                >
                </motion.div>
              </div>

              <div class="landing-nav-item"
                onClick={() => {
                  setnavPage(3)
                }}>
                <p>À Propos</p>

                <motion.div class="selected-nav"
                  initial={{ width: "0%" }}
                  animate={navPage == 3 ? { width: "100%" } : { width: 0 }}

                >

                </motion.div>
              </div>
            </div>
          </div>
        </div>


        <motion.div class="landing-container "
          animate={navPage == 1 ? { top: 0 } : { top: "100%" }}
        >


          <div class="landing-infos bold flex flex-column ">
            <div className="colored-back-text white-text flex align-center">
              <p>Le Haut Niveau</p>
            </div>

            <p className="landing-main-text">
              Soyez le plus rapide dans la livraison de vos articles
            </p>

            <p className="grey-text ">Vos articles nous sont précieux. C’est pourquoi nous accordons la priorité à la sécurité tout au long du processus de livraison. Nos professionnels formés manipulent chaque colis avec le plus grand soin pour s’assurer qu’il arrive à destination en parfait état. Choisissez Korsaa Delivery dès maintenant pour tous vos besoins de livraison et profitez d’un service de livraison fluide et sans stress à travers l’Algérie !</p>

            <div
              className="btn margin-top10 flex align-center justify-center"
              onClick={() => {
                setShowSignUp(true)
              }}
            >
              <p>Rejoignez-Nous</p>
            </div>

          </div>

          <div class="landing-login bold flex flex-column align-center justify-center">

            <div className='login-text'>
              <p className="big-form-text landing-login-text margin-Bottom20">Bienvenue à l’espace client de Korssa</p>
             
            </div>
            <div className="form-container bold">
              <div className="input-container margin-bottom20">
                <p>nom d'utilisateur</p>
                <input type="text" placeholder="Entrez votre nom d’utilisateur ici" value={username} onChange={(e) => {
                  setUsername(e.target.value)
                }} />
              </div>
              <div className="input-container margin-bottom20">
                <div className="input-container">
                  <p>mot de passe</p>
                  <input type="password" placeholder="Entrez votre mot de passe ici" value={password} onChange={(e) => {
                    setPassword(e.target.value)
                  }} />
                </div>
              </div>

              <div className="form-actions flex align-center space-between ">
                <div
                  className="btn orange-back flex align-center relative"
                  onClick={() => {
                    /*
                    //login sucess
                    setShowDashboard(true)
                    setTimeout(() => {
                    navigate('/client', {});
                    }, 1000)
                    */

                    login("lmou", "lmou");
                  }}
                >
                  <motion.p
                    initial={{ opacity: 1 }}
                    animate={!showLoadingLogin ? { opacity: 1 } : { opacity: 0 }}
                  >Envoyer</motion.p>


                  <motion.img className=" absolute login-loading-icon"
                    src={loadingIcon} alt=""

                    initial={{ opacity: 0 }}
                    animate={showLoadingLogin ? { opacity: 1 } : { opacity: 0 }}

                  />
                </div>
                <p className="grey-text cursor ">Mot de passe oublié?</p>

                <motion.p className="popup-text" initial={{ opacity: 0 }} animate={showLoginEmpty ? { opacity: 1 } : { opacity: 0 }}>Fields Empty, Please Fill The Form.</motion.p>
                <motion.p className="popup-text" initial={{ opacity: 0 }} animate={showLoginFailed ? { opacity: 1 } : { opacity: 0 }}>Login failed, please retry later.</motion.p>
              </div>
              <div
                  className="btn margin-top10 flex align-center justify-center"
                  id="signup"
                  onClick={() => {
                    setShowSignUp(true)
                  }}
                >
                  <p>Rejoignez-Nous</p>
                </div>

            </div>
          </div>

        </motion.div>



        <motion.div
          className=" overlay white-text flex align-center justify-center bold max-width max-height orange-back absolute"
          initial={{ opacity: 0, display: "none" }}
          animate={showSignUp ? { opacity: 1, display: "flex" } : { opacity: 0 }}

        >

          <div
            id="signIn-overlay"
            className=" landing-signUp signin-overlay black-text  flex flex-column  align-center justify-center bold">


            <img src={closeImg} className='close-btn' onClick={() => {
              setShowSignUp(false)
            }} />
            <div className="form-container signup-slider">
              <motion.div
                className="email-conf-form"
                initial={{ right: "0" }}
                animate={showEmailConf ? { left: "0" } : { right: "0" }}
              >
                <p className="main-form-text">confirmation d'Email</p>
                <p className="grey-text margin-bottom20">Un e-mail a été envoyé à votre e-mail, s’il vous plaît passé le code ici.</p>

                <div className="input-container">
                  <p>Code</p>
                  <input type="text" placeholder="Entrez le code de confirmation ici" value={emailConf} onChange={(e) => {
                    setEmailConf(e.target.value)
                  }} />
                </div>

                <div className="btn orange-back flex align-center relative margin-top20"
                  onClick={() => {
                    setShowemailConf(true);
                    if (emailConf == codeGen) {
                      signUp();
                      setUsername(clientEmail);

                      setPassword(clientPassword);
                      login()
                      setTimeout(() => {

                        setShowemailConf(false);
                      }, 3000)
                    } else {


                      setTimeout(() => {

                        setShowemailConf(false);
                        setShowEmailConfMsg(true);
                      }, 2000)

                      setTimeout(() => {

                        setShowEmailConfMsg(false);
                      }, 4000)

                    }
                  }}
                >
                  <motion.img className=" absolute login-loading-icon"
                    src={loadingIcon} alt=""

                    initial={{ opacity: 0 }}
                    animate={showemailConf ? { opacity: 1 } : { opacity: 0 }}

                  />
                  <motion.p
                    className=""
                    initial={{ opacity: 0 }}
                    animate={!showemailConf ? { opacity: 1 } : { opacity: 0 }}
                  >Verifier</motion.p>
                </div>

                <motion.p className="grey-text cursor margin-top10"
                  initial={{ opacity: 0 }}
                  animate={showEmailConfMsg ? { opacity: 1, display: "block" } : { opacity: 0 }}
                >
                  Échec de la confirmation.
                </motion.p>


                <div className="input-groupe flex orange-back back-btn"
                  onClick={() => {
                    setShowEmailConf(false);
                    setEmailConf("");
                  }}
                >

                  <motion.img className="" src={arrow} />
                </div>

              </motion.div>

              <motion.div
                className="relative"
                initial={{ left: "0" }}
                animate={showEmailConf ? { left: "-100%" } : { left: "0" }}
              >
                <p className="main-form-text">Rejoignez-nous, vous êtes les bienvenus!</p>
                <p className="grey-text margin-bottom20">Veuillez remplir le formulaire ci-dessous pour creer votre compte</p>


                <div className="input-groupe flex">
                  <div className="input-container margin-right20">
                    <p>Nom</p>
                    <input type="text" placeholder="Entrez votre nom ici" value={clientName} onChange={(e) => {
                      setClientName(e.target.value)
                    }} />
                  </div>
                  <div className="input-container margin-bottom20">
                    <div className="input-container">
                      <p>Email</p>
                      <input type="text" placeholder="Entrez votre Email ici" value={clientEmail} onChange={(e) => {
                        setClientEmail(e.target.value)
                      }} />
                    </div>
                  </div>
                </div>

                <div className="input-groupe flex">
                  <div className="input-container margin-right20">
                    <p>Mot de passe</p>
                    <input type="password" placeholder="Entrez votre mot de passe ici" value={clientPassword} onChange={(e) => {
                      setClientPassword(e.target.value)
                    }} />
                  </div>
                  <div className="input-container margin-bottom20">
                    <div className="input-container">
                      <p>Confirmation de Mot De Passe</p>
                      <input type="password" placeholder="Re-renter Your Password" value={confirmPassword} onChange={(e) => {
                        setConfirmPassword(e.target.value)
                      }} />
                    </div>
                  </div>
                </div>

                <div className="input-groupe flex">
                  <div className="input-container margin-right20">
                    <p>Entreprise</p>
                    <input type="text" placeholder="Entrez le nom de votre entreprise ici" value={clientCompany} onChange={(e) => {
                      setClientCompany(e.target.value)
                    }} />
                  </div>
                  <div className="input-container margin-bottom20">
                    <div className="input-container">
                      <p>Nature de Business</p>
                      <input type="text" placeholder="Entrez la nature de votre Business ici" value={clientBusiness} onChange={(e) => {
                        setClientBusiness(e.target.value)
                      }} />
                    </div>
                  </div>
                </div>

                <div className="input-groupe flex">
                  <div className="input-container margin-right20">
                    <p>Numero de Telephone</p>
                    <input type="text" placeholder="Entrez votre Numero de Telephone ici" value={clientPhone} onChange={(e) => {
                      setClientPhone(e.target.value)
                    }} />
                  </div>
                  <div className="input-container margin-bottom20">
                    <div className="input-container">
                      <p>Ville</p>


                      <select id="wilayaDropdown" value={clientLocation}
                        onChange={(e) => {
                          setClientLocation(e.target.value)
                        }} >
                        {wilayaNames.map((wilaya, index) => (
                          <option key={index} value={wilaya}>
                            {wilaya}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="form-actions flex align-center space-between ">
                  <p></p>
                  <motion.p className="grey-text cursor hidden-msg"
                    initial={{ opacity: 0 }}
                    animate={signUpEmpty ? { opacity: 1, display: "block" } : { opacity: 0 }}
                  >
                    S’inscrire Échec! Champs vides, veuillez remplir le formulaire.
                  </motion.p>

                  <motion.p className="grey-text cursor hidden-msg"
                    initial={{ opacity: 0 }}
                    animate={passwordNotConfirmed ? { opacity: 1, display: "block" } : { opacity: 0 }}
                  >
                    Veuillez confirmer votre mot de passe
                  </motion.p>

                  <div className="btn orange-back flex align-center relative"
                    onClick={() => {
                      sendEmail();
                    }}
                  >
                    <motion.img className=" absolute login-loading-icon"
                      src={loadingIcon} alt=""

                      initial={{ opacity: 0 }}
                      animate={showLoadingSignUp ? { opacity: 1 } : { opacity: 0 }}

                    />
                    <motion.p
                      className=""
                      initial={{ opacity: 0 }}
                      animate={!showLoadingSignUp ? { opacity: 1 } : { opacity: 0 }}
                    >S'inscrire</motion.p>
                  </div>
                </div>


              </motion.div>
            </div>

          </div>


        </motion.div>


      </motion.div>

    </motion.div>
  )
}

export default Landingpage;
